import ConfirmationTerm from './confirmation-term';

export default ConfirmationTerm;
